import React, { Component } from 'react';

import { Link } from 'react-router-dom';

import Image from 'Demora/image';

import ReduxConnect from 'Demora/redux-connect';

import moment from 'moment';

import { Tooltip } from 'reactstrap';

import Feel from './Feels/Feel';

import FeedItemActions from './Actions/FeedItemActions';

import NextToNameComments from 'resources/assets/react-app/uiHooks/react-social/nextToNameComments';

import Loading from 'Demora/Loading';

import ShowPostText from './FeedItem/ShowPostText';

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

import ReplyTo from './ReplyTo';

class Comment extends Component {
	constructor(props) {
		super(props);

		this.state = {
			toggleToolTipPostAge: {},
		};

		this.uniqueID =
			this.props.comment.id.replace(/[^a-zA-z0-9]/g, '') + new Date().getTime();
	}

	togglePostAge = (post) => {
		let t = this.state.toggleToolTipPostAge;

		t[post] = !t[post];

		this.setState({
			toggleToolTipPostAge: t,
		});
	}

	toggleLightBox = (img) => {
		this.setState({
			imageInLightBox: img,
		});
	}

	render() {
		let props = this.props;

		let comment = props.comment;

		let user = props.users[comment.u + '-u'];

		if (comment.d == 1 || !user) {
			return null;
		}

		let tooltipTimestamp = 'comment_age' + this.uniqueID;

		return (
			<li className='comment'>
				{comment.temp ? (
					<div className='newComment text-center'>
						<Loading />
					</div>
				) : (
					''
				)}
				{props.showEx && (
					<div className='text-center'>
						<a href='#' onClick={props.showMoreComments}>
							<i className='fa fa-ellipsis-h fa-3x' aria-hidden='true'></i>
						</a>
					</div>
				)}
				<Link to={'/profile/' + comment.u + '-u'} className='float-left'>
					<img
						className='avatar rounded'
						src={Image(user.image, 50)}
						alt='avatar'
					/>
				</Link>
				<div className='comment-body'>
					<FeedItemActions
						className='commentFeedActions'
						post={comment}
						viewer={props.viewer}
					/>
					<div className='comment-text'>
						<span className='comment-user-name'>
							<Link to={'/profile/' + comment.u + '-u'}>
								{user.first_name + ' ' + user.last_name}
								<NextToNameComments obj={user.id + '-u'} />
							</Link>
						</span>
						{!comment.m.m ? '' : <ShowPostText post={comment} />}
					</div>
					<div className='post-image text-center'>
						{!comment.m.i
							? ''
							: comment.m.i.map((im, i) => {
									return (
										<p key={i}>
											<img
												src={Image(im, '0')}
												style={{ maxWidth: '50%' }}
												className='rounded'
												onClick={() => this.toggleLightBox(Image(im, 0))}
											/>
										</p>
									);
								})}
					</div>
					<Feel post={comment} viewer={props.viewer} />

					<ReplyTo comment={comment} />

					{!props.dontShowTime && (
						<span id={tooltipTimestamp} className='time'>
							&nbsp;
							<br />
							{moment.utc(comment.t).local().from()}
						</span>
					)}
					{!props.dontShowTime && (
						<Tooltip
							placement='top'
							isOpen={this.state.toggleToolTipPostAge[tooltipTimestamp]}
							target={tooltipTimestamp}
							toggle={() => this.togglePostAge(tooltipTimestamp)}
						>
							{moment.utc(comment.t).local().format('lll')}
						</Tooltip>
					)}
				</div>
				<Lightbox
					open={!!this.state.imageInLightBox}
					close={() => this.toggleLightBox('')}
					slides={[
						{ src: this.state.imageInLightBox },
					]}
				/>
			</li>
		);
	}
}

export default ReduxConnect(Comment, {
	user: 'user',
	users: 'users',
});
